import React from "react";

Page404.propTypes = {};

function Page404(props) {
  return <div>Page not found</div>;
}

export default Page404;
